//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'select-owner-modal',
    props: {
        onSelected: Function
    },
    data() {
        const vm = this;
        return {
            loading: false,
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            searchInput: {},
            list: [],
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '姓名',
                    key: 'name'
                },
                {
                    title: '昵称',
                    key: 'nickName'
                },
                {
                    title: '性别',
                    key: 'projectStages',
                    render: (h, params) => {
                        const row = params.row;
                        var str = '其他';
                        if (row.gender === 1) {
                            str = '男';
                        } else if (row.gender === 2) {
                            str = '女';
                        }
                        return h('span', str);
                    }
                },
                {
                    title: '生日',
                    render: (h, params) => {
                        const row = params.row;
                        if (row.brithDay != null) {
                            return h('span', new Date(row.brithDay).toLocaleDateString());
                        } else {
                            return h('span', '');
                        }

                    }
                },
                {
                    title: '操作',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        var edit = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.onRowClick(params.row);
                                }
                            }
                        }, '选择');
                        actions.push(edit);
                        return h('div', actions);
                    }
                }
            ]
        };
    },
    methods: {
        pageChange(page) {
            // this.$store.commit('project/setCurrentPage', page);
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            // this.$store.commit('project/setPageSize', pagesize);
            this.pageSize = pagesize;
            this.getPage();
        },
        async getPage() {
            this.loading = true;
            let page = {
                projectName: this.searchInput.projectName,
                cityName: this.searchInput.cityName,
                // projectId: this.projectId,
                maxResultCount: this.pageSize,
                skipCount: (this.currentPage - 1) * this.pageSize
            };
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.searchInput.isOwner = true;
            await abp.ajax.post('/api/services/app/Member/SearchMembers', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });

        },
        onRowClick(row, index) {
            const vm = this;
            if (vm.onSelected !== undefined) {
                vm.onSelected(row);
            }
        }
    },
    created() {
        this.getPage();
    }
};
